import { OrderData } from './order-data';
import { ExternalReport } from './external-report';
import { OrderAuditEntity, OrderAuditContactEntity } from './order-audit';
import { OrderRecord } from './order-record';
import type { OrderPreRating } from './order-pre-rating';

export interface OrderEntity {
  // MySQL Fields
  orderNo: string;
  storeId: number;
  orderStatus: OrderStatus;
  rrzuStatus?: number;
  auditStatus: number;
  deliveryStatus?: number;
  cancelStatus: number;
  userPhone: string;
  userName: string;
  userIdCard: string;
  orderCreatedAt: string;
  riskType: string;
  blindType: string;
  productTitle: string;
  productBrand: string;
  productSku: string;
  productQuality: string;
  preprocessOperatorId?: number;
  decisionOperatorId?: number;
  decisionTime?: string;
  auditId: number;
  logisticsNo?: string;
  logisticsStatus?: string;
  cancelType: string;
  cancelCategory: string;
  cancelReason: string;
  cancelEvidence: any;
  receiptEvidence: string;
  cancelBeginTime?: string;
  finishedTime?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MergedOrder {
  order: OrderEntity;
  orderData?: OrderData | null;
  orderRecord?: OrderRecord | null;
  buerReport?: ExternalReport | null;
  audit?: OrderAuditEntity | null;
  auditContacts?: OrderAuditContactEntity[] | null;
  /** 订单预评级（T1 风控 + T2 利润 + T3 综合）*/
  preRating?: OrderPreRating | null;
}

export enum OrderStatus {
  PreProcess = 1,
  Audit = 3,
  Decision = 5,
  PendingDelivery = 9,  // 待发货
  Shipped = 13,
  Leased = 15,
  Returning = 17,
  Outbound = 23,
  Inbound = 25,
  Cancelled = 30,
}

export const OrderStatusMap: Record<number, string> = {
  1: '预处理中',
  3: '审核中',
  5: '决策中',
  9: '待发货',
  13: '已发货',
  15: '租赁中',
  17: '归还中',
  23: '已出库',
  25: '已入库',
  30: '已取消',
  91: '已转单',
};

export enum OrderType {
  Normal = 0,
  Renewal = 1,
  Compensation = 2,
  DepositSupplement = 3,
  RentSupplement = 4,
  Freight = 5,
  Buy = 6,
  OtherNonDevice = 7,
}

export const OrderTypeMap: Record<number, string> = {
  [OrderType.Normal]: '常规订单',
  [OrderType.Renewal]: '续租订单',
  [OrderType.Compensation]: '赔偿金',
  [OrderType.DepositSupplement]: '补押金',
  [OrderType.RentSupplement]: '补租金',
  [OrderType.Freight]: '运费',
  [OrderType.Buy]: '购买订单',
  [OrderType.OtherNonDevice]: '其他非设备订单',
};

export const RiskTypeMap: Record<string, string> = {
  PASS: '通过',
  PRE_PAY: '预收',
  HIGH_RISK: '高风险',
};

export const BlindTypeMap: Record<string, string> = {
  BLIND: '盲发',
  MUST_BLIND: '盲发必发',
};

export enum OrderTabScene {
  GroupPre = 'tab:group_pre',
  GroupAuditWait = 'tab:group_audit_wait',
  GroupAuditTodo = 'tab:group_audit_todo',
  GroupAuditDone = 'tab:group_audit_done',
  GroupAllAuditDone = 'tab:group_all_audit_done',
  GroupAll = 'tab:group_all',
  GroupNonDevice = 'tab:group_non_device',
  GroupRenewal = 'tab:group_renewal',
  GroupDecision = 'tab:group_decision',
  GroupDeliveryManagement = 'tab:group_delivery_management',
  GroupReceiptManagement = 'tab:group_receipt_management',
}
